import { css } from 'styled-components';
import { StyledComboboxInput } from '../../components/ComboboxInput/ComboboxInput.styles';
import { StyledInput } from '../../components/Input/Input.styles';
export var DropdownSelectMixin = function DropdownSelectMixin() {
  return css(["", ":not([disabled]),", ":not([disabled]){cursor:pointer;}"], StyledComboboxInput, StyledInput);
};